<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
    dashboard
  >
    <v-layout
      v-if="getWhiteLabel && getUser && !$apollo.loading"
      wrap
      justify-center
      mt-1
      ml-1
      mr-1
      mb-3
    >
      <v-flex
        v-if="!dashBoardExists"
        pl-0
        pr-0
      >
        <v-card v-if="getUser && isOwner && !$apollo.loading">
          <v-layout
            wrap
            align-center
            pl-0
          >
            <v-flex
              md6
              xs12
              pa-5
            >
              <div class="mb-2">
                <b>{{ $t('drawer.dashboard') }}</b>
              </div>
              <small>{{ $t('traderdashboard.empty') }}</small>
            </v-flex>
            <v-flex
              md6
              xs12
              style="text-align:right;"
            >
              <v-btn
                small
                class="primary"
                @click="$router.push('/whitelabels')"
              >
                {{ $t('globals.continueButton') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
        <v-flex
          v-if="getUser && !isOwner && getUserPermissions"
          class="not-found"
        >
          <v-card>
            <v-icon>mdi-ghost</v-icon>
            <p>{{ $t('members.notAccessDashboard') }}</p>
          </v-card>
        </v-flex>
      </v-flex>
      <v-tabs
        v-if="dashBoardExists && !$apollo.loading"
        v-model="tab"
        class="mb-6"
      >
        <v-tab
          v-for="(n,i) in modules"
          :key="i"
          :href="`#${n.public_config.admin_dashboard.component}`"
          @click="changeTab(n.public_config.admin_dashboard.component)"
        >
          {{ n.public_config.admin_dashboard.name[$i18n.locale] }}
        </v-tab>
      </v-tabs>
      <v-tabs-items
        v-if="dashBoardExists"
        v-model="tab"
      >
        <v-tab-item
          v-for="(m, o) in modules"
          :key="o"
          :transition="false"
          :reverse-transition="false"
          :value="m.public_config.admin_dashboard.component"
        >
          <component
            :is="m.public_config.admin_dashboard.component"
            v-if="tab == m.public_config.admin_dashboard.component"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-layout>
    <v-layout
      v-if="!getWhiteLabel"
      wrap
      justify-center
    >
      <helper-start-white-label />
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import SpotFutures from "@/views/Modules/SpotFutures/Dashboard/View.vue";
import Products from "@/views/Modules/Products/Dashboard/View.vue";

export default {
  name: "Dashboard",
  components: {
    Products,
    SpotFutures
  },
  data() {
    return {
      tooltip: null,
      loading: false,
      tab: null,
    }
  },
  computed: {
    ...mapGetters('user', ['getUser', "getUserPermissions", "isOwner"]),
    ...mapGetters("whitelabel", ["getWhiteLabel"]),
    ...mapState('app', ['loader']),
    dashBoardExists() {
      if (!this.getWhiteLabel || this.getWhiteLabel.modules.length == 0) {
        return false
      }
      return this.isOwner
        ? this.getWhiteLabel.modules.find(item => (item.public_config.admin_dashboard && item.public_config.admin_dashboard.show))
        : this.getUserPermissions ? this.getWhiteLabel.modules.find(item => (item.public_config.admin_dashboard && item.public_config.admin_dashboard.show && this.dashboardPermission())) : false
    },
    modules() {
      if (!this.getWhiteLabel || this.getWhiteLabel.modules.length == 0) {
        return null
      }
      const modules = this.isOwner
        ? this.getWhiteLabel.modules.filter(item => (item.public_config.admin_dashboard && item.public_config.admin_dashboard.show))
        : this.getWhiteLabel.modules.filter(item => (item.public_config.admin_dashboard && item.public_config.admin_dashboard.show && item.public_config.admin_dashboard.component !== 'spot-futures'))
      if(modules) {
        modules.sort((a, b) => {
          var x = a.public_config.admin_dashboard.order; var y = b.public_config.admin_dashboard.order;
          return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });
      }

      let modulesMap = new Map()
      let result = []
      if(modules) {
        modules.map(item => {
          modulesMap.set(item.public_config.admin_dashboard.component, item)
        })
      }
      for (let [key, value] of modulesMap) {
        result.push(value)
      }
      return result
    }
  },
  methods: {
    changeTab(tab) {
      this.tab = tab
    },
    dashboardPermission() {
      const permissionCheck = this.getUserPermissions.find(item => item.key === "dashboard");
      return permissionCheck && permissionCheck.permissions.find(item => (item.name === 'whitelabel_stats' && item.connected))
    },
  },
}
</script>

<style lang="scss">
.dashboard .v-tabs-items {
  width: 100%!important
}
</style>

